import { auth } from './firebase';

export const API_BASE = process.env.REACT_APP_API_URL || '';

// §5 Auth — Identity Platform ONLY. The Supabase session fallbacks were removed
// 2026-07-06 after the post-cutover soak; auth.currentUser is the single source
// of identity. Returns null when signed out (apiFetch then omits auth headers).
export async function getAuthToken() {
  try {
    if (auth.currentUser) {
      const t = await auth.currentUser.getIdToken();
      if (t) return t;
    }
  } catch { /* signed out or token refresh failed */ }
  return null;
}

// Resolve the current practice_id from the Identity Platform custom claim.
export async function getCurrentPracticeId() {
  try {
    if (auth.currentUser) {
      const r = await auth.currentUser.getIdTokenResult();
      if (r?.claims?.practice_id) return r.claims.practice_id;
    }
  } catch { /* signed out */ }
  return null;
}

// Resolve basic identity (uid + email) for attribution/display.
export async function getCurrentUserInfo() {
  if (auth.currentUser) {
    return { uid: auth.currentUser.uid, email: auth.currentUser.email || null };
  }
  return { uid: null, email: null };
}

// Builds the dual auth headers the gateway needs: the gateway validates + REPLACES
// Authorization with its own Google token, so functions read the real client token
// from X-Supabase-Token. Any code calling a gateway function directly (raw fetch)
// MUST send both — prefer apiFetch, or spread these.
export async function authHeaders() {
  const token = await getAuthToken();
  return token
    ? { 'Authorization': `Bearer ${token}`, 'X-Supabase-Token': token }
    : {};
}

// invite-user goes through the API Gateway like everything else (route added in
// config v21). RESOLVED 2026-06-28: the earlier v19/v20 breakage was the wrong
// backend-auth service account (compute SA instead of api-gateway-invoker@) — not
// the route or the spec. The direct Cloud Run URL fallback is no longer needed
// (org policy blocks public Cloud Run anyway).
export const INVITE_USER_URL = 'invite-user';

export const apiFetch = async (path, opts = {}) => {
  const isAbsolute = /^https?:\/\//i.test(path);
  const url = isAbsolute ? path : (API_BASE ? `${API_BASE}/${path}` : `/api/${path}`);

  // Attach auth headers for gateway calls AND absolute-URL calls (e.g. invite-user
  // direct to Cloud Run). Local /api/* dev proxy doesn't need them.
  if (API_BASE || isAbsolute) {
    const extra = await authHeaders();
    if (extra.Authorization) {
      opts = { ...opts, headers: { ...opts.headers, ...extra } };
    }
  }

  return fetch(url, opts);
};
